import type { ISize } from '~/helpers/types';
import type {
  IAppPreviewActionOptions,
  IAppPreviewOpenOptions,
} from './AppPreviewDispatchContext';
import type { IAppPreviewRoute, IAppPreviewState } from './AppPreviewState';

type IAction =
  | {
      type: 'NAVIGATE_TO_ROUTE';
      route: IAppPreviewRoute;
    }
  | {
      type: 'NAVIGATE_TO_URL';
      url: string;
    }
  | {
      type: 'SET_ERROR_MESSAGE';
      errorMessage: string;
    }
  | {
      type: 'SET_OPENED';
      opened: boolean;
      options?: IAppPreviewOpenOptions;
    }
  | {
      type: 'SET_HIDDEN';
      hidden: boolean;
    }
  | {
      type: 'SET_IFRAME_REF';
      iframeRef?: React.RefObject<HTMLIFrameElement>;
    }
  | {
      type: 'SET_SIZE';
      size: ISize;
      options?: IAppPreviewActionOptions;
    }
  | { type: 'SAVE_STATE' }
  | { type: 'RESTORE_STATE' };

export const makeAppPreviewReducer =
  (savedStateRef: React.MutableRefObject<IAppPreviewState>) =>
  (state: IAppPreviewState, action: IAction): IAppPreviewState => {
    switch (action.type) {
      case 'NAVIGATE_TO_ROUTE':
        return {
          ...state,
          route: action.route,
          url: undefined,
          errorMessage: undefined,
        };

      case 'NAVIGATE_TO_URL':
        return {
          ...state,
          route: undefined,
          url: action.url,
          errorMessage: undefined,
        };

      case 'SET_ERROR_MESSAGE':
        return {
          ...state,
          errorMessage: action.errorMessage,
        };

      case 'SET_OPENED':
        if (action.options?.persistent === true) {
          // eslint-disable-next-line no-param-reassign
          savedStateRef.current = {
            ...savedStateRef.current,
            opened: action.opened,
          };
        }

        return {
          ...state,
          opened: action.opened,
          ...(action.opened && action.options?.maximize
            ? { width: Infinity, height: Infinity }
            : undefined),
        };

      case 'SET_HIDDEN':
        return {
          ...state,
          hidden: action.hidden,
        };

      case 'SET_IFRAME_REF':
        return {
          ...state,
          iframeRef: action.iframeRef,
        };

      case 'SET_SIZE':
        if (action.options?.persistent === true) {
          // eslint-disable-next-line no-param-reassign
          savedStateRef.current = {
            ...savedStateRef.current,
            width: action.size.width,
            height: action.size.height,
          };
        }

        return {
          ...state,
          width: action.size.width,
          height: action.size.height,
        };

      case 'SAVE_STATE':
        // eslint-disable-next-line no-param-reassign
        savedStateRef.current = state;

        return {
          ...state,
        };

      case 'RESTORE_STATE':
        return {
          ...savedStateRef.current,
        };
    }
  };
